module.exports = __webpack_public_path__ + "img/disc.f5bde8cf.svg";